export enum OneLineArticleSaleMode {
  Disabled = 'Disabled',
  SingleArticle = 'SingleArticle',
  NoQuantityLimit = 'NoQuantityLimit'
}
